import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '@components/global/Layout';
import type { GetStaticPropsContext, GetStaticPropsResult } from 'next';
import { getAllStoresDataForSetMyStore } from '@adapters/prismic/fetching/stores';
import { MyStoreData } from '@adapters/prismic/fetching/stores/types';
import MegaMenu from '_components/MegaMenu/Desktop';
import { NavUIContextProvider } from '@context/MainNavContext/NavigationState';
import { getPreviewRef } from '@adapters/prismic/utils/getPreviewRef';
import getPromoBarData from '@adapters/prismic/fetching/promos/getPromoBarData';

interface MECStores {
  stores: MyStoreData[];
}

export async function getStaticPaths() {
  return {
    paths: [{ params: { locale: 'en' } }, { params: { locale: 'fr' } }],
    fallback: false,
  };
}

export async function getStaticProps({
  params,
  previewData,
  preview = false,
}: GetStaticPropsContext): Promise<GetStaticPropsResult<MECStores> | null> {
  const locale = params?.locale === 'fr' ? 'fr' : 'en';
  if (!locale) {
    throw new Error('No locale specified for page');
  }

  const previewRef = getPreviewRef(preview, previewData);

  const [stores, promoBarData, serverSideTranslation] =
    await Promise.allSettled([
      getAllStoresDataForSetMyStore(locale),
      locale && getPromoBarData(locale),
      serverSideTranslations(locale, ['common', 'promotions', 'organization']),
    ]).then((results) =>
      results.map((promise) => {
        if (
          promise.status === 'rejected' ||
          typeof promise.value === 'undefined'
        ) {
          console.error('promise rejected or returning undefined', promise);
          return null;
        }
        return promise.value;
      })
    );

  return {
    props: {
      stores,
      ...serverSideTranslation,
      promoBarData,
    },
  };
}

export default function TestPage() {
  return (
    <div>
      <NavUIContextProvider>
        <MegaMenu />
      </NavUIContextProvider>
      <p>Hello World!</p>
    </div>
  );
}

TestPage.Layout = Layout;
